
/** ------------------------------------------------------
 * THIS FILE WAS AUTOMATICALLY GENERATED (DO NOT MODIFY)
 * -------------------------------------------------------
 */

/* tslint:disable */
/* eslint-disable */
export enum CurrencyCode {
    CZK = "CZK",
    EUR = "EUR"
}

export enum PrinterConnectionType {
    LAN = "LAN",
    Bluetooth = "Bluetooth",
    USB = "USB"
}

export enum Country {
    Afghanistan = "Afghanistan",
    AlandIslands = "AlandIslands",
    Albania = "Albania",
    Algeria = "Algeria",
    AmericanSamoa = "AmericanSamoa",
    Andorra = "Andorra",
    Angola = "Angola",
    Anguilla = "Anguilla",
    Antarctica = "Antarctica",
    AntiguaAndBarbuda = "AntiguaAndBarbuda",
    Argentina = "Argentina",
    Armenia = "Armenia",
    Aruba = "Aruba",
    Australia = "Australia",
    Austria = "Austria",
    Azerbaijan = "Azerbaijan",
    Bahamas = "Bahamas",
    Bahrain = "Bahrain",
    Bangladesh = "Bangladesh",
    Barbados = "Barbados",
    Belarus = "Belarus",
    Belgium = "Belgium",
    Belize = "Belize",
    Benin = "Benin",
    Bermuda = "Bermuda",
    Bhutan = "Bhutan",
    Bolivia = "Bolivia",
    BosniaAndHerzegovina = "BosniaAndHerzegovina",
    Botswana = "Botswana",
    BouvetIsland = "BouvetIsland",
    Brazil = "Brazil",
    BritishIndianOceanTerritory = "BritishIndianOceanTerritory",
    BruneiDarussalam = "BruneiDarussalam",
    Bulgaria = "Bulgaria",
    BurkinaFaso = "BurkinaFaso",
    Burundi = "Burundi",
    Cambodia = "Cambodia",
    Cameroon = "Cameroon",
    Canada = "Canada",
    CapeVerde = "CapeVerde",
    CaymanIslands = "CaymanIslands",
    CentralAfricanRepublic = "CentralAfricanRepublic",
    Chad = "Chad",
    Chile = "Chile",
    China = "China",
    ChristmasIsland = "ChristmasIsland",
    CocosKeelingIslands = "CocosKeelingIslands",
    Colombia = "Colombia",
    Comoros = "Comoros",
    Congo = "Congo",
    CongoDemocraticRepublic = "CongoDemocraticRepublic",
    CookIslands = "CookIslands",
    CostaRica = "CostaRica",
    CoteDIvoire = "CoteDIvoire",
    Croatia = "Croatia",
    Cuba = "Cuba",
    Cyprus = "Cyprus",
    CzechRepublic = "CzechRepublic",
    Denmark = "Denmark",
    Djibouti = "Djibouti",
    Dominica = "Dominica",
    DominicanRepublic = "DominicanRepublic",
    Ecuador = "Ecuador",
    Egypt = "Egypt",
    ElSalvador = "ElSalvador",
    EquatorialGuinea = "EquatorialGuinea",
    Eritrea = "Eritrea",
    Estonia = "Estonia",
    Ethiopia = "Ethiopia",
    FalklandIslands = "FalklandIslands",
    FaroeIslands = "FaroeIslands",
    Fiji = "Fiji",
    Finland = "Finland",
    France = "France",
    FrenchGuiana = "FrenchGuiana",
    FrenchPolynesia = "FrenchPolynesia",
    FrenchSouthernTerritories = "FrenchSouthernTerritories",
    Gabon = "Gabon",
    Gambia = "Gambia",
    Georgia = "Georgia",
    Germany = "Germany",
    Ghana = "Ghana",
    Gibraltar = "Gibraltar",
    Greece = "Greece",
    Greenland = "Greenland",
    Grenada = "Grenada",
    Guadeloupe = "Guadeloupe",
    Guam = "Guam",
    Guatemala = "Guatemala",
    Guernsey = "Guernsey",
    Guinea = "Guinea",
    GuineaBissau = "GuineaBissau",
    Guyana = "Guyana",
    Haiti = "Haiti",
    HeardIslandMcdonaldIslands = "HeardIslandMcdonaldIslands",
    HolySeeVaticanCityState = "HolySeeVaticanCityState",
    Honduras = "Honduras",
    HongKong = "HongKong",
    Hungary = "Hungary",
    Iceland = "Iceland",
    India = "India",
    Indonesia = "Indonesia",
    Iran = "Iran",
    Iraq = "Iraq",
    Ireland = "Ireland",
    IsleOfMan = "IsleOfMan",
    Israel = "Israel",
    Italy = "Italy",
    Jamaica = "Jamaica",
    Japan = "Japan",
    Jersey = "Jersey",
    Jordan = "Jordan",
    Kazakhstan = "Kazakhstan",
    Kenya = "Kenya",
    Kiribati = "Kiribati",
    Korea = "Korea",
    Kuwait = "Kuwait",
    Kyrgyzstan = "Kyrgyzstan",
    LaoPeoplesDemocraticRepublic = "LaoPeoplesDemocraticRepublic",
    Latvia = "Latvia",
    Lebanon = "Lebanon",
    Lesotho = "Lesotho",
    Liberia = "Liberia",
    LibyanArabJamahiriya = "LibyanArabJamahiriya",
    Liechtenstein = "Liechtenstein",
    Lithuania = "Lithuania",
    Luxembourg = "Luxembourg",
    Macao = "Macao",
    Macedonia = "Macedonia",
    Madagascar = "Madagascar",
    Malawi = "Malawi",
    Malaysia = "Malaysia",
    Maldives = "Maldives",
    Mali = "Mali",
    Malta = "Malta",
    MarshallIslands = "MarshallIslands",
    Martinique = "Martinique",
    Mauritania = "Mauritania",
    Mauritius = "Mauritius",
    Mayotte = "Mayotte",
    Mexico = "Mexico",
    Micronesia = "Micronesia",
    Moldova = "Moldova",
    Monaco = "Monaco",
    Mongolia = "Mongolia",
    Montenegro = "Montenegro",
    Montserrat = "Montserrat",
    Morocco = "Morocco",
    Mozambique = "Mozambique",
    Myanmar = "Myanmar",
    Namibia = "Namibia",
    Nauru = "Nauru",
    Nepal = "Nepal",
    Netherlands = "Netherlands",
    NetherlandsAntilles = "NetherlandsAntilles",
    NewCaledonia = "NewCaledonia",
    NewZealand = "NewZealand",
    Nicaragua = "Nicaragua",
    Niger = "Niger",
    Nigeria = "Nigeria",
    Niue = "Niue",
    NorfolkIsland = "NorfolkIsland",
    NorthernMarianaIslands = "NorthernMarianaIslands",
    Norway = "Norway",
    Oman = "Oman",
    Pakistan = "Pakistan",
    Palau = "Palau",
    PalestinianTerritory = "PalestinianTerritory",
    Panama = "Panama",
    PapuaNewGuinea = "PapuaNewGuinea",
    Paraguay = "Paraguay",
    Peru = "Peru",
    Philippines = "Philippines",
    Pitcairn = "Pitcairn",
    Poland = "Poland",
    Portugal = "Portugal",
    PuertoRico = "PuertoRico",
    Qatar = "Qatar",
    Reunion = "Reunion",
    Romania = "Romania",
    RussianFederation = "RussianFederation",
    Rwanda = "Rwanda",
    SaintBarthelemy = "SaintBarthelemy",
    SaintHelena = "SaintHelena",
    SaintKittsAndNevis = "SaintKittsAndNevis",
    SaintLucia = "SaintLucia",
    SaintMartin = "SaintMartin",
    SaintPierreAndMiquelon = "SaintPierreAndMiquelon",
    SaintVincentAndGrenadines = "SaintVincentAndGrenadines",
    Samoa = "Samoa",
    SanMarino = "SanMarino",
    SaoTomeAndPrincipe = "SaoTomeAndPrincipe",
    SaudiArabia = "SaudiArabia",
    Senegal = "Senegal",
    Serbia = "Serbia",
    Seychelles = "Seychelles",
    SierraLeone = "SierraLeone",
    Singapore = "Singapore",
    Slovakia = "Slovakia",
    Slovenia = "Slovenia",
    SolomonIslands = "SolomonIslands",
    Somalia = "Somalia",
    SouthAfrica = "SouthAfrica",
    SouthGeorgiaAndSandwichIsl = "SouthGeorgiaAndSandwichIsl",
    Spain = "Spain",
    SriLanka = "SriLanka",
    Sudan = "Sudan",
    Suriname = "Suriname",
    SvalbardAndJanMayen = "SvalbardAndJanMayen",
    Swaziland = "Swaziland",
    Sweden = "Sweden",
    Switzerland = "Switzerland",
    SyrianArabRepublic = "SyrianArabRepublic",
    Taiwan = "Taiwan",
    Tajikistan = "Tajikistan",
    Tanzania = "Tanzania",
    Thailand = "Thailand",
    TimorLeste = "TimorLeste",
    Togo = "Togo",
    Tokelau = "Tokelau",
    Tonga = "Tonga",
    TrinidadAndTobago = "TrinidadAndTobago",
    Tunisia = "Tunisia",
    Turkey = "Turkey",
    Turkmenistan = "Turkmenistan",
    TurksAndCaicosIslands = "TurksAndCaicosIslands",
    Tuvalu = "Tuvalu",
    Uganda = "Uganda",
    Ukraine = "Ukraine",
    UnitedArabEmirates = "UnitedArabEmirates",
    UnitedKingdom = "UnitedKingdom",
    UnitedStates = "UnitedStates",
    UnitedStatesOutlyingIslands = "UnitedStatesOutlyingIslands",
    Uruguay = "Uruguay",
    Uzbekistan = "Uzbekistan",
    Vanuatu = "Vanuatu",
    Venezuela = "Venezuela",
    VietNam = "VietNam",
    VirginIslandsBritish = "VirginIslandsBritish",
    VirginIslandsUS = "VirginIslandsUS",
    WallisAndFutuna = "WallisAndFutuna",
    WesternSahara = "WesternSahara",
    Yemen = "Yemen",
    Zambia = "Zambia",
    Zimbabwe = "Zimbabwe"
}

export enum OrderCancelationReason {
    PersonnelError = "PersonnelError",
    ClientError = "ClientError",
    Other = "Other"
}

export enum AccountingItemState {
    Opened = "Opened",
    Canceled = "Canceled",
    Paid = "Paid",
    Voided = "Voided",
    Moved = "Moved",
    SoftRemoved = "SoftRemoved"
}

export enum FiscalRecordState {
    Attempted = "Attempted",
    Reported = "Reported"
}

export enum PaymentMethod {
    Cash = "Cash",
    CreditCard = "CreditCard"
}

export enum BillState {
    Voided = "Voided",
    Paid = "Paid"
}

export enum Culture {
    cs_CZ = "cs_CZ",
    en_US = "en_US"
}

export enum Role {
    Admin = "Admin",
    User = "User"
}

export enum ReviewState {
    Pending = "Pending",
    Approved = "Approved",
    Declined = "Declined"
}

export enum Color {
    Blue = "Blue",
    Purple = "Purple",
    Orange = "Orange",
    Green = "Green"
}

export enum DeductionReason {
    Waste = "Waste",
    Movement = "Movement"
}

export enum StockLevelModifierType {
    OrderLine = "OrderLine",
    DeductionListItem = "DeductionListItem",
    DeliveryListItem = "DeliveryListItem",
    InventoryCountItem = "InventoryCountItem"
}

export enum UnitType {
    Kg = "Kg",
    Liter = "Liter",
    Pcs = "Pcs",
    Gr = "Gr",
    Ml = "Ml"
}

export enum StockCardPricingMode {
    LastDelivery = "LastDelivery",
    Average = "Average"
}

export enum OrderEvent {
    Created = "Created",
    PaidPartially = "PaidPartially",
    PaidCompletely = "PaidCompletely",
    CanceledPartially = "CanceledPartially",
    CanceledCompletely = "CanceledCompletely",
    MovedPartially = "MovedPartially",
    MovedCompletely = "MovedCompletely",
    QuickSale = "QuickSale",
    OrderLinesAdded = "OrderLinesAdded",
    BillVoided = "BillVoided",
    MovedAndJoined = "MovedAndJoined",
    OrderLinesMovedTo = "OrderLinesMovedTo",
    OrderLinesMovedFrom = "OrderLinesMovedFrom",
    AddedCustomName = "AddedCustomName",
    Scheduled = "Scheduled",
    Rescheduled = "Rescheduled"
}

export enum OrderState {
    Opened = "Opened",
    Closed = "Closed",
    Canceled = "Canceled",
    ClosedAndJoined = "ClosedAndJoined"
}

export enum OrderUpdateTypes {
    Created = "Created",
    PaidPartially = "PaidPartially",
    PaidCompletely = "PaidCompletely",
    CanceledPartially = "CanceledPartially",
    CanceledCompletely = "CanceledCompletely",
    MovedPartially = "MovedPartially",
    MovedCompletely = "MovedCompletely",
    OrderLinesAdded = "OrderLinesAdded",
    MovedAndJoined = "MovedAndJoined",
    JoinedPartially = "JoinedPartially",
    NameUpdated = "NameUpdated",
    CreatedAndPaid = "CreatedAndPaid",
    OrderLinesAddedAndScheduled = "OrderLinesAddedAndScheduled",
    OrderLinesAddedAndRescheduled = "OrderLinesAddedAndRescheduled",
    Scheduled = "Scheduled",
    Rescheduled = "Rescheduled"
}

export enum SortOrder {
    ASC = "ASC",
    DESC = "DESC"
}

export enum AbiType {
    arm64 = "arm64",
    armeabi = "armeabi",
    x86_64 = "x86_64"
}

export interface Pagination {
    offset?: number;
    limit?: number;
}

export interface BillFilters {
    place?: string;
    openedBy?: string;
    billNumber?: string;
    name?: string;
    cashRegisterId?: string;
    date?: DateFromTo;
    dateFromTo?: DateFromTo;
    moreFilters?: MoreFiltersBill;
}

export interface DateFromTo {
    from: Date;
    to: Date;
}

export interface MoreFiltersBill {
    cash: boolean;
    card: boolean;
    reported: boolean;
    notReported: boolean;
    voidedOnly: boolean;
    paidOnly?: boolean;
}

export interface OrderFilters {
    place?: string;
    openedBy?: string;
    name?: string;
    date?: DateFromTo;
    moreFilters?: MoreFiltersOrder;
}

export interface MoreFiltersOrder {
    multiple: boolean;
    single: boolean;
    onPlace: boolean;
    toGo: boolean;
    open: boolean;
    closed: boolean;
    canceled: boolean;
}

export interface CustomerFilters {
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
    totalSpent?: number;
    deleteDate?: Date;
    birthday?: DateFromTo;
}

export interface AccountCreate {
    id?: string;
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    imageUrl?: string;
}

export interface AccountUpdate {
    firstName?: string;
    lastName?: string;
    email?: string;
    password?: string;
    imageUrl?: string;
}

export interface UpdateBillPrinter {
    cashRegisterId: string;
    billPrinterId: string;
}

export interface CashRegisterCreate {
    deviceId: string;
    name: string;
    model: string;
    isMainRegister: boolean;
    billPrinterId?: string;
    parentCashRegisterId?: string;
    venueId?: string;
}

export interface DeviceCreate {
    deviceId: string;
    name: string;
    type: string;
    connectionType: PrinterConnectionType;
    customName?: string;
}

export interface VenueCreate {
    id?: string;
    name: string;
    locality: string;
    thoroughfare: string;
    premise: string;
    postalCode: string;
    eetId: string;
    defaultTimezone?: string;
    defaultLocale?: string;
    pohodaCentreId?: string;
}

export interface VenueUpdate {
    name?: string;
    locality?: string;
    thoroughfare?: string;
    premise?: string;
    postalCode?: string;
    eetId?: string;
    defaultTimezone?: string;
    defaultLocale?: string;
    pohodaCentreId?: string;
}

export interface UpdateCategory {
    name?: string;
    ordering?: number;
    description?: string;
    parentCategoryId?: string;
    color?: Color;
}

export interface RecipeLineCreate {
    waste: number;
    quantity: number;
    stockCardId: string;
    recipeId: string;
    warehouseId: string;
    id?: string;
}

export interface RecipeLineUpdate {
    waste?: number;
    quantity?: number;
    stockCardId?: string;
    recipeId?: string;
    warehouseId?: string;
    id: string;
}

export interface WarehouseCreate {
    name: string;
    id?: string;
    venueIds: string[];
}

export interface WarehouseUpdate {
    name?: string;
    venueIds?: string[];
}

export interface StockCardCreate {
    name: string;
    sku?: string;
    storageUnit: UnitType;
    conversionUnit?: UnitType;
    convertedAmount?: number;
    manualPriceOverride?: boolean;
    priceBuy?: number;
    pricingMode?: StockCardPricingMode;
    stockCardCategoryId?: string;
    taxId: string;
    id?: string;
    sharedStockCardId?: string;
    warehouseIds?: string[];
}

export interface StockCardUpdate {
    name?: string;
    sku?: string;
    manualPriceOverride?: boolean;
    priceBuy?: number;
    pricingMode?: StockCardPricingMode;
    stockCardCategoryId?: string;
    taxId?: string;
    warehouseIds?: string[];
}

export interface RecipeCreate {
    name: string;
    id?: string;
    recipeLines?: RecipeLineCascadeCreate[];
    recipeIds?: string[];
}

export interface RecipeLineCascadeCreate {
    waste: number;
    quantity: number;
    stockCardId: string;
    warehouseId: string;
    id?: string;
}

export interface RecipeUpdate {
    name?: string;
    recipeIds?: string[];
    id: string;
    recipeLines?: RecipeLineCascadeUpdate[];
}

export interface RecipeLineCascadeUpdate {
    waste?: number;
    quantity?: number;
    stockCardId?: string;
    warehouseId?: string;
    id?: string;
}

export interface ProductCreate {
    priceSell: number;
    priceBuy?: number;
    name: string;
    description?: string;
    displayName?: string;
    SKU?: string;
    imageUrl?: string;
    showInPos: boolean;
    discountable?: boolean;
    categoryId: string;
    taxId: string;
    toGoTaxId?: string;
    pohodaStockItemId?: string;
    connectedWarehouseCardId?: string;
    id?: string;
    priceBuyCurrencyCode?: CurrencyCode;
    printingDeviceIds?: string[];
    stockCardId?: string;
    stockCardWarehouseId?: string;
}

export interface RecipeCreateWithProduct {
    id?: string;
    recipeLines?: RecipeLineCascadeCreate[];
    recipeIds?: string[];
}

export interface ProductUpdate {
    priceSell?: number;
    priceBuy?: number;
    name?: string;
    description?: string;
    displayName?: string;
    SKU?: string;
    imageUrl?: string;
    showInPos?: boolean;
    discountable?: boolean;
    categoryId?: string;
    taxId?: string;
    toGoTaxId?: string;
    pohodaStockItemId?: string;
    connectedWarehouseCardId?: string;
    priceBuyCurrencyCode?: CurrencyCode;
    printingDeviceIds?: string[];
    stockCardId?: string;
    stockCardWarehouseId?: string;
}

export interface RecipeUpdateWithProduct {
    id?: string;
    recipeLines?: RecipeLineCascadeCreate[];
    recipeIds?: string[];
}

export interface DiscountCreate {
    rate: number;
    name: string;
    description?: string;
}

export interface DiscountUpdate {
    id: string;
    rate?: number;
    name?: string;
    description?: string;
}

export interface EmployeeRegister {
    venueIds: string[];
    defaultVenueId: string;
    firstName: string;
    lastName: string;
    email: string;
    role?: Role;
    password: string;
    pin?: string;
    imageUrl?: string;
}

export interface EmployeeUpdate {
    venueIds?: string[];
    defaultVenueId?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    pin?: string;
    role?: Role;
    password?: string;
}

export interface UpdateBill {
    id: string;
    paymentMethod: PaymentMethod;
}

export interface EnterpriseCreate {
    id?: string;
    legalName: string;
    country: Country;
    locality: string;
    thoroughfare: string;
    premise: string;
    postalCode: string;
    tin: string;
}

export interface EnterpriseUpdate {
    legalName?: string;
    country?: Country;
    locality?: string;
    thoroughfare?: string;
    premise?: string;
    postalCode?: string;
    tin?: string;
}

export interface OrderDiscountInput {
    orderId: string;
    orderLines: OrderLineDto[];
    discountId: string;
}

export interface OrderLineDto {
    id: string;
    quantity: number;
}

export interface OrderCreate {
    id?: string;
    placeId?: string;
    scheduledDate?: Date;
    name?: string;
    lines: OrderLineCreate[];
}

export interface OrderLineCreate {
    id?: string;
    quantity: number;
    orderId?: string;
    productId: string;
    note?: string;
}

export interface OrderCreateAndPay {
    id?: string;
    placeId?: string;
    lines: OrderLineCreate[];
    paymentMethod: PaymentMethod;
    cashRegisterdId: string;
    issueDate?: Date;
    note?: string;
    isToGo: boolean;
    discountId?: string;
    scheduledDate?: Date;
    customerId?: string;
}

export interface AddToOrder {
    id: string;
    lines: OrderLineCreate[];
    scheduledDate?: Date;
}

export interface PayOrder {
    id: string;
    paymentMethod: PaymentMethod;
    cashRegisterdId: string;
    issueDate?: Date;
    note?: string;
    discountId?: string;
    isToGo?: boolean;
    customerId?: string;
}

export interface OrderSplit {
    id: string;
    paymentMethod: PaymentMethod;
    cashRegisterdId: string;
    issueDate?: Date;
    note?: string;
    discountId?: string;
    isToGo?: boolean;
    customerId?: string;
    orderLines: OrderLineDto[];
}

export interface OrderCancel {
    id: string;
    reason: OrderCancelationReason;
    note?: string;
}

export interface CancelOrderLines {
    id: string;
    reason: OrderCancelationReason;
    orderLines: OrderLineDto[];
}

export interface MoveOrder {
    id: string;
    placeId?: string;
    targetOrderId?: string;
}

export interface MoveOrderLines {
    id: string;
    placeId?: string;
    targetOrderId?: string;
    orderLines: OrderLineDto[];
}

export interface ScheduleOrder {
    id: string;
    scheduledDate: Date;
}

export interface UpdateOrderName {
    id: string;
    name: string;
}

export interface PlaceCreate {
    id?: string;
    name: string;
    coordinateX: number;
    coordinateY: number;
    sectionId: string;
}

export interface PlaceUpdate {
    name?: string;
    isToGo?: boolean;
    coordinateX?: number;
    coordinateY?: number;
}

export interface SectionUpdateName {
    name: string;
}

export interface SectionUpdateOrder {
    orderedSections: SectionWithOrder[];
}

export interface SectionWithOrder {
    id: string;
    ordering: number;
}

export interface LoginEmployee {
    password: string;
    email: string;
}

export interface StartVenueShift {
    id?: string;
    startedUtc?: Date;
    initialCashAmount: number;
}

export interface FinishVenueShift {
    finishedUtc?: Date;
    expectedCashAmount: number;
    finalCashAmount: number;
    expectedCreditCardAmount: number;
    finalCreditCardAmount: number;
}

export interface CreateCashDrawerOperation {
    venueShiftId: string;
    amount: number;
    id?: string;
    createdUtc?: Date;
    note?: string;
}

export interface CustomerCreate {
    firstName: string;
    lastName?: string;
    email: string;
    birthday?: Date;
    phoneNumber?: string;
    id?: string;
}

export interface CustomerUpdate {
    firstName?: string;
    lastName?: string;
    email?: string;
    birthday?: Date;
    phoneNumber?: string;
    id: string;
}

export interface StockCardCategoryCreate {
    name: string;
    color?: Color;
    id?: string;
}

export interface StockCardCategoryUpdate {
    name?: string;
    color?: Color;
}

export interface InventoryCountItemCreate {
    stockCardId: string;
    id?: string;
}

export interface InventoryCountItemUpdate {
    realCount: number;
    unitType: UnitType;
}

export interface DeliveryListCreate {
    invoiceNumber?: string;
    deliveryDateUtc: Date;
    warehouseId: string;
    id?: string;
    deliveryListItems?: DeliveryListItemCreate[];
}

export interface DeliveryListItemCreate {
    quantity: number;
    priceWithoutVat: number;
    stockCardId: string;
    id?: string;
}

export interface DeliveryListUpdate {
    invoiceNumber?: string;
    deliveryDateUtc?: Date;
    id: string;
    warehouseId: string;
}

export interface SupplierCreate {
    legalName: string;
    country: Country;
    city: string;
    district?: string;
    headquarters: string;
    postalCode: string;
    tin: string;
    companyIdentificationNumber: string;
    id?: string;
}

export interface SupplierUpdate {
    legalName?: string;
    country?: Country;
    city?: string;
    district?: string;
    headquarters?: string;
    postalCode?: string;
    tin?: string;
    companyIdentificationNumber?: string;
    id: string;
}

export interface DeductionListItemUpdate {
    quantity?: number;
    stockCardId?: string;
}

export interface DeductionListItemCreate {
    quantity: number;
    deductionListId: string;
    stockCardId: string;
    id?: string;
}

export interface DeductionListCreate {
    deductionDateUtc: Date;
    deductionReason: DeductionReason;
    warehouseId: string;
    id?: string;
    deductionListItems?: DeductionListItemCascadeCreate[];
}

export interface DeductionListItemCascadeCreate {
    quantity: number;
    stockCardId: string;
    id?: string;
}

export interface DeductionListUpdate {
    deductionDateUtc?: Date;
    deductionReason?: DeductionReason;
    id: string;
    warehouseId: string;
}

export interface Currency {
    currencyCode: CurrencyCode;
    precision: number;
}

export interface CashRegister {
    id: string;
    name: string;
    model: string;
    immerlyPosVersion?: string;
    isMainRegister: boolean;
    createdUtc: Date;
    updatedUtc?: Date;
    deleteDateUtc?: Date;
    venueId: string;
    venue: Venue;
    billPrinterId?: string;
    billPrinter?: Device;
    assignedPrinters?: Device[];
    parentCashRegisterId?: string;
    parentCashRegister?: CashRegister;
}

export interface Device {
    id: string;
    deviceId: string;
    name: string;
    type: string;
    connectionType?: PrinterConnectionType;
    customName?: string;
    venue: Venue;
    products?: Product[];
    cashRegisterId?: string;
    cashRegister?: Device;
}

export interface Section {
    id: string;
    name: string;
    createdAt: Date;
    ordering?: number;
    deleteDate?: Date;
    places?: Place[];
    venue: Venue;
}

export interface Tax {
    id: string;
    name: string;
    rate: number;
    countryCode: Country;
}

export interface Discount {
    id: string;
    name: string;
    description?: string;
    rate: number;
    deleteDate?: Date;
    venue: Venue;
}

export interface OrderLine {
    id: string;
    quantity: number;
    createdUtc: Date;
    closedUtc?: Date;
    updatedUtc?: Date;
    deleteDateUtc?: Date;
    canceledUtc?: Date;
    cancelationReason?: OrderCancelationReason;
    price: number;
    discountedPrice?: number;
    discountValue?: number;
    unitPrice: number;
    discountedUnitPrice?: number;
    orderLineState: AccountingItemState;
    note?: string;
    version: number;
    orderId: string;
    productId: string;
    billId?: string;
    taxId?: string;
    priceCurrencyCurrencyCode: CurrencyCode;
    venue: Venue;
    canceledBy?: Employee;
    priceCurrency: Currency;
    order: Order;
    bill?: Bill;
    product: Product;
    tax?: Tax;
    discount?: Discount;
}

export interface FiscalRecord {
    id: string;
    attemptedToReportUtc: Date;
    revenueDateUtc: Date;
    fiscalCode?: string;
    taxIdentifierNumber: string;
    cashRegisterdId: string;
    payerSecurityCode: string;
    payerSignatureCode: string;
    premisesId: string;
    state: FiscalRecordState;
    rawReportedValue: number;
    formattedReportedValue: string;
    createdUtc: Date;
    updatedUtc: Date;
    billId: string;
    venue: Venue;
    bill: Bill;
}

export interface BillTaxes {
    id: string;
    netPrice: number;
    taxValue: number;
    grossTotal: number;
    billId: string;
    taxId: string;
    tax: Tax;
    bill: Bill;
}

export interface Customer {
    id: string;
    firstName: string;
    lastName?: string;
    email: string;
    birthday?: Date;
    phoneNumber?: string;
    enterpriseId: string;
    totalSpent: number;
    deleteDate?: Date;
    bills?: Bill[];
}

export interface Bill {
    id: string;
    billNumber: string;
    note: string;
    paymentMethod: PaymentMethod;
    total: number;
    dicountedTotalValue?: number;
    discountedValue?: number;
    rounding?: number;
    roundedPrice?: number;
    issuedUtc: Date;
    canceledUtc?: Date;
    billState: BillState;
    version: number;
    isToGo: boolean;
    orderId: string;
    totalPriceCurrencyCurrencyCode: CurrencyCode;
    venueId: string;
    placeId?: string;
    issuedById: string;
    canceledById?: string;
    venue: Venue;
    totalPriceCurrency: Currency;
    order: Order;
    place?: Place;
    issuedBy: Employee;
    canceledBy?: Employee;
    orderLines: OrderLine[];
    billTaxes: BillTaxes[];
    fiscalRecord?: FiscalRecord;
    cashRegisterId?: string;
    cashRegister?: CashRegister;
    customerId?: string;
    customer?: Customer;
}

export interface Place {
    id: string;
    name: string;
    coordinateX: number;
    coordinateY: number;
    dimensionX: number;
    dimensionY: number;
    deleteDate?: Date;
    sectionId: string;
    venueId: string;
    isToGo: boolean;
    venue: Venue;
    waiter?: Employee;
    orders?: Order[];
    bills?: Bill[];
    section: Section;
}

export interface Account {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    imageUrl?: string;
    cultureCode?: Culture;
    languageCode?: Culture;
    employee?: Employee;
}

export interface Shift {
    id: string;
    start: Date;
    end?: Date;
    employeeId: string;
    employee: Employee;
}

export interface Employee {
    id: string;
    pin?: string;
    role: Role;
    deleteDate?: Date;
    accountId: string;
    currentVenueId: string;
    enterpriseId: string;
    currentVenue: Venue;
    venues: Venue[];
    account: Account;
    enterprise: Enterprise;
    shifts: Shift[];
    places: Place[];
    closedOrders: Order[];
    openedOrders: Order[];
}

export interface Supplier {
    id: string;
    createdAtUtc: Date;
    updatedAtUtc?: Date;
    deleteDateUtc?: Date;
    version: number;
    createdById: string;
    updatedById?: string;
    deletedById?: string;
    legalName: string;
    country: Country;
    city: string;
    district?: string;
    headquarters: string;
    postalCode: string;
    tin: string;
    companyIdentificationNumber: string;
    reviewState: ReviewState;
}

export interface Enterprise {
    id: string;
    legalName: string;
    country?: Country;
    city: string;
    district?: string;
    headquarters: string;
    premise: string;
    postalCode: string;
    tin: string;
    companyIdentificationNumber: string;
    premisesId?: string;
    employees?: Employee[];
    stockCards?: StockCard[];
    stockCardCategories?: StockCardCategory[];
    venues?: Venue[];
    customers?: Customer[];
    suppliers?: Supplier[];
}

export interface StockCardCategory {
    id: string;
    createdAtUtc: Date;
    updatedAtUtc?: Date;
    deleteDateUtc?: Date;
    version: number;
    createdById: string;
    updatedById?: string;
    deletedById?: string;
    name: string;
    stockCards?: StockCard[];
    color?: Color;
    enterprise: Enterprise;
    enterpriseId: string;
}

export interface DeliveryListItem {
    id: string;
    createdAtUtc: Date;
    updatedAtUtc?: Date;
    deleteDateUtc?: Date;
    version: number;
    createdById: string;
    updatedById?: string;
    deletedById?: string;
    quantity: number;
    priceWithoutVat: number;
    deliveryList: DeliveryList;
    deliveryListId: string;
    stockCard: StockCard;
    stockCardId: string;
}

export interface DeliveryList {
    id: string;
    createdAtUtc: Date;
    updatedAtUtc?: Date;
    deleteDateUtc?: Date;
    version: number;
    createdById: string;
    updatedById?: string;
    deletedById?: string;
    invoiceNumber?: string;
    deliveryDateUtc: Date;
    isProcessed?: boolean;
    warehouse: Warehouse;
    warehouseId: string;
    deliveryListItems?: DeliveryListItem[];
}

export interface DeductionListItem {
    id: string;
    createdAtUtc: Date;
    updatedAtUtc?: Date;
    deleteDateUtc?: Date;
    version: number;
    createdById: string;
    updatedById?: string;
    deletedById?: string;
    quantity: number;
    deductionListId: string;
    stockCard: StockCard;
    stockCardId: string;
}

export interface DeductionList {
    id: string;
    createdAtUtc: Date;
    updatedAtUtc?: Date;
    deleteDateUtc?: Date;
    version: number;
    createdById: string;
    updatedById?: string;
    deletedById?: string;
    deductionDateUtc: Date;
    isProcessed?: boolean;
    deductionReason: DeductionReason;
    warehouse: Warehouse;
    warehouseId: string;
    deductionListItems?: DeductionListItem[];
}

export interface StockLevelHistory {
    id: string;
    newValue: number;
    oldValue?: number;
    quantityChanged: number;
    modifierId: string;
    modifierType: StockLevelModifierType;
    createdAtUtc: Date;
    stockLevelId: string;
    stockLevel: StockLevel;
}

export interface StockLevel {
    id: string;
    createdAtUtc: Date;
    updatedAtUtc?: Date;
    deleteDateUtc?: Date;
    version: number;
    createdById: string;
    updatedById?: string;
    deletedById?: string;
    quantity: number;
    warehouse: Warehouse;
    warehouseId: string;
    stockCard: StockCard;
    stockCardId: string;
    history?: StockLevelHistory[];
}

export interface Warehouse {
    id: string;
    createdAtUtc: Date;
    updatedAtUtc?: Date;
    deleteDateUtc?: Date;
    version: number;
    createdById: string;
    updatedById?: string;
    deletedById?: string;
    name: string;
    enterprise: Enterprise;
    enterpriseId: string;
    inventoryCounts?: InventoryCount[];
    deliveryLists?: DeliveryList[];
    deductionLists?: DeductionList[];
    stockLevels?: StockLevel[];
    stockCards?: StockCard[];
    stockCardCategories?: StockCardCategory[];
    venueIds: string[];
}

export interface InventoryCount {
    id: string;
    createdAtUtc: Date;
    updatedAtUtc?: Date;
    deleteDateUtc?: Date;
    version: number;
    createdById: string;
    updatedById?: string;
    deletedById?: string;
    startDate: Date;
    expectedValuation: number;
    realValuation?: number;
    endDate?: Date;
    inventoryCountItems: InventoryCountItem[];
    warehouse: Warehouse;
    warehouseId: string;
}

export interface InventoryCountItem {
    id: string;
    createdAtUtc: Date;
    updatedAtUtc?: Date;
    deleteDateUtc?: Date;
    version: number;
    createdById: string;
    updatedById?: string;
    deletedById?: string;
    realCount?: number;
    expectedCount: number;
    pricePerUnitWithoutVAT: number;
    inventoryCount: InventoryCount;
    inventoryCountId: string;
    stockCard: StockCard;
    stockCardId: string;
}

export interface SharedStockCard {
    id: string;
    createdAtUtc: Date;
    updatedAtUtc?: Date;
    deleteDateUtc?: Date;
    version: number;
    createdById: string;
    updatedById?: string;
    deletedById?: string;
    name: string;
    sku?: string;
    storageUnit: UnitType;
    conversionUnit?: UnitType;
    convertedAmount?: number;
    reviewState: ReviewState;
    stockCards?: StockCard[];
}

export interface StockCard {
    id: string;
    createdAtUtc: Date;
    updatedAtUtc?: Date;
    deleteDateUtc?: Date;
    version: number;
    createdById: string;
    updatedById?: string;
    deletedById?: string;
    name: string;
    sku?: string;
    storageUnit: UnitType;
    conversionUnit?: UnitType;
    convertedAmount?: number;
    manualPriceOverride?: boolean;
    priceBuy?: number;
    pricingMode?: StockCardPricingMode;
    enterprise: Enterprise;
    enterpriseId: string;
    stockCardCategory?: StockCardCategory;
    stockCardCategoryId?: string;
    sharedStockCard: SharedStockCard;
    sharedStockCardId: string;
    inventoryCountItems?: InventoryCountItem[];
    recipeLines?: RecipeLine[];
    deliveryListItems?: DeliveryListItem[];
    deductionListItems?: DeductionListItem[];
    stockLevels: StockLevel[];
    warehouses: Warehouse[];
    tax: Tax;
    taxId: string;
}

export interface RecipeLine {
    id: string;
    createdAtUtc: Date;
    updatedAtUtc?: Date;
    deleteDateUtc?: Date;
    version: number;
    createdById: string;
    updatedById?: string;
    deletedById?: string;
    waste: number;
    quantity: number;
    stockCard: StockCard;
    stockCardId: string;
    recipe: Recipe;
    recipeId: string;
    warehouseId: string;
}

export interface Recipe {
    id: string;
    createdAtUtc: Date;
    updatedAtUtc?: Date;
    deleteDateUtc?: Date;
    version: number;
    createdById: string;
    updatedById?: string;
    deletedById?: string;
    name: string;
    products?: Product[];
    recipes: Recipe[];
    recipeLines: RecipeLine[];
    enterprise: Enterprise;
    enterpriseId: string;
}

export interface ConnectedStockCard {
    id: string;
    createdAtUtc: Date;
    updatedAtUtc?: Date;
    deleteDateUtc?: Date;
    version: number;
    createdById: string;
    updatedById?: string;
    deletedById?: string;
    quantity: number;
    stockCard: StockCard;
    stockCardId: string;
    warehouseId: string;
    venue: Venue;
    venueId: string;
    products?: Product[];
}

export interface Product {
    id: string;
    priceSell: number;
    priceBuy?: number;
    name: string;
    description?: string;
    displayName?: string;
    SKU?: string;
    imageUrl?: string;
    showInPos: boolean;
    discountable: boolean;
    deleteDate?: Date;
    categoryId: string;
    taxId: string;
    toGoTaxId?: string;
    venueId: string;
    priceBuyCurrencyCurrencyCode?: CurrencyCode;
    pohodaStockItemId?: string;
    venue: Venue;
    priceBuyCurrency?: Currency;
    category: Category;
    recipe?: Recipe;
    connectedStockCard?: ConnectedStockCard;
    connectedWarehouseCardId?: string;
    recipeId?: string;
    tax: Tax;
    toGoTax?: Tax;
    orderLines?: OrderLine[];
    printingDevices: Device[];
}

export interface Category {
    id: string;
    name: string;
    description?: string;
    imageUrl?: string;
    color?: Color;
    ordering?: number;
    deleteDate?: Date;
    venueId: string;
    categoryId?: string;
    venue: Venue;
    products?: Product[];
    category?: Category;
}

export interface LegalEntity {
    id: string;
    legalName: string;
    country?: Country;
    city: string;
    district?: string;
    headquarters: string;
    postalCode: string;
    tin: string;
    companyIdentificationNumber: string;
    venues?: Venue[];
}

export interface Venue {
    id: string;
    name: string;
    locality: string;
    thoroughfare: string;
    premise: string;
    postalCode: string;
    eetId?: string;
    defaultTimezone: string;
    cultureCode: string;
    languageCode: string;
    enterpriseId: string;
    defaultCurrencyCurrencyCode: CurrencyCode;
    pohodaCentreId?: string;
    defaultCurrency: Currency;
    categories?: Category[];
    places?: Place[];
    products?: Product[];
    employees?: Employee[];
    enterprise: Enterprise;
    orders?: Order[];
    bills?: Bill[];
    orderLines?: OrderLine[];
    sections?: Section[];
    discounts?: Discount[];
    legalEntity: LegalEntity;
    legalEntityId: string;
    warehouses?: Warehouse[];
}

export interface OrderHistory {
    id: string;
    changeReason: OrderEvent;
    createdAt: Date;
    auditId: string;
    order: Order;
}

export interface Order {
    id: string;
    orderNumber?: string;
    name?: string;
    createdUtc: Date;
    closedUtc?: Date;
    canceledUtc?: Date;
    updatedUtc: Date;
    scheduledUtc?: Date;
    orderState: OrderState;
    cancelReason?: OrderCancelationReason;
    cancelNote?: string;
    isToGo: boolean;
    version: number;
    venue: Venue;
    venueId: string;
    joinedOrder?: Order;
    place?: Place;
    placeId?: string;
    openedBy: Employee;
    openedById: string;
    updatedBy?: Employee;
    updatedById: string;
    closedBy?: Employee;
    closedById?: string;
    canceledBy?: Employee;
    canceledById: string;
    orderLines: OrderLine[];
    bills: Bill[];
    orderHistory: OrderHistory[];
}

export interface VenueShift {
    id: string;
    startedUtc: Date;
    finishedUtc?: Date;
    initialCashAmount: number;
    expectedCashAmount?: number;
    finalCashAmount?: number;
    expectedCreditCardAmount?: number;
    finalCreditCardAmount?: number;
    cashIncome?: number;
    venue: Venue;
    startedBy: Employee;
    startedById: string;
    finishedBy?: Employee;
    finishedById: string;
    cashDrawerOperations: CashDrawerOperation[];
    cashRegisterId?: string;
    cashRegister?: CashRegister;
}

export interface CashDrawerOperation {
    id: string;
    amount: number;
    createdUtc: Date;
    note?: string;
    venue: Venue;
    createdBy: Employee;
    createdById: string;
    venueShift: VenueShift;
    venueShiftId: string;
    cashRegisterId?: string;
    cashRegister?: CashRegister;
}

export interface CategoryProductCount {
    categoryId: string;
    productCount: number;
}

export interface PaginatedProducts {
    items: Product[];
    count: number;
}

export interface FiscalRegistryCertificate {
    id: string;
    name: string;
    encoding: string;
    mimetype: string;
    content: string;
    integrations: FiscalIntegration[];
}

export interface FiscalIntegration {
    id: string;
    certificatePassword: string;
    createdUtc: Date;
    deleteDate?: Date;
    venue: Venue;
    certificate: FiscalRegistryCertificate;
}

export interface UpdateOrderLine {
    quantity: number;
    productId: string;
    note?: string;
}

export interface OrderUpdatesSubscription {
    orders: Order[];
    orderUpdateType: OrderUpdateTypes;
    issuedCashRegisterId: string;
    updatedOrderLines?: UpdateOrderLine[];
}

export interface BillDiscountPreview {
    id: string;
    billNumber: string;
    note: string;
    paymentMethod: PaymentMethod;
    total: number;
    dicountedTotalValue?: number;
    discountedValue?: number;
    rounding?: number;
    roundedPrice?: number;
    issuedUtc: Date;
    canceledUtc?: Date;
    billState: BillState;
    version: number;
    isToGo: boolean;
    orderId: string;
    totalPriceCurrencyCurrencyCode: CurrencyCode;
    venueId: string;
    placeId?: string;
    issuedById: string;
    canceledById?: string;
    totalPriceCurrency: Currency;
    cashRegisterId?: string;
    cashRegister?: CashRegister;
    customerId?: string;
    customer?: Customer;
}

export interface OrderLineDiscountPreview {
    id: string;
    quantity: number;
    createdUtc: Date;
    closedUtc?: Date;
    updatedUtc?: Date;
    deleteDateUtc?: Date;
    canceledUtc?: Date;
    cancelationReason?: OrderCancelationReason;
    price: number;
    discountedPrice?: number;
    discountValue?: number;
    unitPrice: number;
    discountedUnitPrice?: number;
    orderLineState: AccountingItemState;
    note?: string;
    version: number;
    orderId: string;
    productId: string;
    billId?: string;
    taxId?: string;
    priceCurrencyCurrencyCode: CurrencyCode;
    priceCurrency: Currency;
    product: Product;
    discount?: Discount;
}

export interface OrderDiscountPreview {
    id: string;
    orderNumber?: string;
    name?: string;
    createdUtc: Date;
    closedUtc?: Date;
    canceledUtc?: Date;
    updatedUtc: Date;
    scheduledUtc?: Date;
    orderState: OrderState;
    cancelReason?: OrderCancelationReason;
    cancelNote?: string;
    isToGo: boolean;
    version: number;
    venueId: string;
    placeId?: string;
    openedById: string;
    updatedById: string;
    closedById?: string;
    canceledById: string;
    orderLines: OrderLineDiscountPreview[];
    bills: BillDiscountPreview[];
}

export interface ChartData {
    income: number;
    date: Date;
    paymentMethod: PaymentMethod;
}

export interface PendingOrdersInfo {
    orderQuantity: number;
    pendingTotalPrice: number;
}

export interface TopCategories {
    id: string;
    name: string;
    quantity: number;
    totalPriceSold: number;
}

export interface TopEmployees {
    id: string;
    firstName: string;
    lastName: string;
    billCount: number;
    totalPriceSold: number;
}

export interface TopProducts {
    id: string;
    name: string;
    quantity: number;
    price: number;
    totalPriceSold: number;
}

export interface TopTable {
    id: string;
    name: string;
    orderQuantity: number;
    totalPriceSold: number;
}

export interface VoidedBills {
    itemCount: number;
    voidedValue: number;
}

export interface DiscountedOrderLines {
    itemCount: number;
    discountedValue: number;
}

export interface CanceledOrderLines {
    itemCount: number;
    canceledValue: number;
}

export interface ProductStatistic {
    id: string;
    quantity: number;
    revenue: number;
    productName: string;
}

export interface PaginatedProductStatistic {
    items: ProductStatistic[];
    count: number;
}

export interface ExpectedVenueShiftAmounts {
    expectedByCard: number;
    expectedByCash: number;
}

export interface Manifest {
    current: string;
    latest: string;
}

export interface IQuery {
    accounts(): Account[] | Promise<Account[]>;
    account(id: string): Account | Promise<Account>;
    cashRegisters(): CashRegister[] | Promise<CashRegister[]>;
    cashRegister(deviceId: string): CashRegister | Promise<CashRegister>;
    cashRegisterByDeviceId(deviceId: string): CashRegister | Promise<CashRegister>;
    devices(): Device[] | Promise<Device[]>;
    device(id: string): Device | Promise<Device>;
    venues(): Venue[] | Promise<Venue[]>;
    venue(id: string): Venue | Promise<Venue>;
    categories(categoryType?: string): Category[] | Promise<Category[]>;
    category(id: string): Category | Promise<Category>;
    categoriesProductCount(): CategoryProductCount[] | Promise<CategoryProductCount[]>;
    recipeLinesByIds(ids: string[]): RecipeLine[] | Promise<RecipeLine[]>;
    recipeLine(id: string): RecipeLine | Promise<RecipeLine>;
    sharedStockCards(offset?: number, limit?: number, name?: string, sku?: string): SharedStockCard[] | Promise<SharedStockCard[]>;
    sharedStockCard(id: string): SharedStockCard | Promise<SharedStockCard>;
    warehouses(onlyCurrentVenue?: boolean): Warehouse[] | Promise<Warehouse[]>;
    warehouse(id: string): Warehouse | Promise<Warehouse>;
    stockCards(warehouseIds: string[], offset?: number, limit?: number, nameOrSku?: string, stockCardCategoryId?: string): StockCard[] | Promise<StockCard[]>;
    stockCard(id: string): StockCard | Promise<StockCard>;
    recipies(offset?: number, limit?: number, stockCardId?: string): Recipe[] | Promise<Recipe[]>;
    recipe(id: string): Recipe | Promise<Recipe>;
    products(): Product[] | Promise<Product[]>;
    paginatedProducts(pagination?: Pagination, name?: string, categories?: string[]): PaginatedProducts | Promise<PaginatedProducts>;
    productsByCategory(categoryId: string): Product[] | Promise<Product[]>;
    product(id: string): Product | Promise<Product>;
    taxes(): Tax[] | Promise<Tax[]>;
    tax(id: string): Tax | Promise<Tax>;
    discounts(): Discount[] | Promise<Discount[]>;
    discount(id: string): Discount | Promise<Discount>;
    employees(): Employee[] | Promise<Employee[]>;
    removedEmployees(): Employee[] | Promise<Employee[]>;
    employee(id: string): Employee | Promise<Employee>;
    removedEmployee(id: string): Employee | Promise<Employee>;
    bills(offset?: number, limit?: number, pagination?: Pagination, filters?: BillFilters): Bill[] | Promise<Bill[]>;
    bill(id: string): Bill | Promise<Bill>;
    enterprises(): Enterprise[] | Promise<Enterprise[]>;
    enterprise(id: string): Enterprise | Promise<Enterprise>;
    orders(offset?: number, limit?: number, filters?: OrderFilters): Order[] | Promise<Order[]>;
    openedOrders(): Order[] | Promise<Order[]>;
    order(id: string, onlyOpenedItems?: boolean): Order | Promise<Order>;
    places(): Place[] | Promise<Place[]>;
    place(id: string): Place | Promise<Place>;
    sections(): Section[] | Promise<Section[]>;
    section(id: string): Section | Promise<Section>;
    timeline(orderId: string): Timeline[] | Promise<Timeline[]>;
    shifts(): Shift[] | Promise<Shift[]>;
    shift(id: string): Shift | Promise<Shift>;
    topCategories(dateFromTo?: DateFromTo): TopCategories[] | Promise<TopCategories[]>;
    unpopularCategories(dateFromTo?: DateFromTo): TopCategories[] | Promise<TopCategories[]>;
    topEmployees(dateFromTo?: DateFromTo): TopEmployees[] | Promise<TopEmployees[]>;
    topProducts(dateFromTo?: DateFromTo): TopProducts[] | Promise<TopProducts[]>;
    unpopularProducts(dateFromTo?: DateFromTo): TopProducts[] | Promise<TopProducts[]>;
    topTable(dateFromTo?: DateFromTo): TopTable | Promise<TopTable>;
    pendingOrders(): PendingOrdersInfo | Promise<PendingOrdersInfo>;
    salesChart(dateFilter?: DateFromTo): ChartData[] | Promise<ChartData[]>;
    voidedBills(dateFromTo?: DateFromTo): VoidedBills | Promise<VoidedBills>;
    discountedOrderLines(dateFromTo?: DateFromTo): DiscountedOrderLines | Promise<DiscountedOrderLines>;
    canceledOrderLines(dateFromTo?: DateFromTo): CanceledOrderLines | Promise<CanceledOrderLines>;
    productStatistics(offset?: number, limit?: number, productName?: string, dateFromTo?: DateFromTo, revenueSortOrder?: SortOrder, quantitySortOrder?: SortOrder): PaginatedProductStatistic | Promise<PaginatedProductStatistic>;
    productsReport(dateFromTo?: DateFromTo): string | Promise<string>;
    pohodaIssueSlip(dateFromTo?: DateFromTo): string | Promise<string>;
    cashDrawerReport(dateFromTo?: DateFromTo): string | Promise<string>;
    moneyFlowReport(dateFromTo?: DateFromTo): string | Promise<string>;
    venueShifts(offset?: number, limit?: number, pagination?: Pagination, dateFromTo?: DateFromTo): VenueShift[] | Promise<VenueShift[]>;
    venueShift(id: string): VenueShift | Promise<VenueShift>;
    getLastClosedShift(): VenueShift | Promise<VenueShift>;
    getExpectedOpenedShiftAmount(): ExpectedVenueShiftAmounts | Promise<ExpectedVenueShiftAmounts>;
    cashDrawerOperations(): CashDrawerOperation[] | Promise<CashDrawerOperation[]>;
    cashDrawerOperation(id: string): CashDrawerOperation | Promise<CashDrawerOperation>;
    posManifest(): Manifest | Promise<Manifest>;
    posUpdateUrl(abi: AbiType): string | Promise<string>;
    customer(id: string): Customer | Promise<Customer>;
    customers(offset?: number, limit?: number, filters?: CustomerFilters, multivalueSearch?: string): Customer[] | Promise<Customer[]>;
    stockCardCategories(offset?: number, limit?: number, name?: string): StockCardCategory[] | Promise<StockCardCategory[]>;
    stockCardCategory(id: string): StockCardCategory | Promise<StockCardCategory>;
    inventoryCountItem(id: string, inventoryCountId: string): InventoryCountItem | Promise<InventoryCountItem>;
    inventoryCountItems(inventoryCountId: string, offset?: number, limit?: number): InventoryCountItem[] | Promise<InventoryCountItem[]>;
    inventoryCounts(warehouseId: string, offset?: number, limit?: number, dateFromTo?: DateFromTo): InventoryCount[] | Promise<InventoryCount[]>;
    currentInventoryCount(warehouseId: string): InventoryCount | Promise<InventoryCount>;
    inventoryCount(id: string, warehouseId: string): InventoryCount | Promise<InventoryCount>;
    deliveryLists( warehouseId: string, offset?: number, limit?: number, supplierId?: string, invoiceNumber?: string, deliveryDateUtc?: Date, isProcessed?: boolean): DeliveryList[] | Promise<DeliveryList[]>;
    deliveryList(id: string, warehouseId: string): DeliveryList | Promise<DeliveryList>;
    suppliers(offset?: number, limit?: number, legalName?: string, tin?: string): Supplier[] | Promise<Supplier[]>;
    supplier(id: string): Supplier | Promise<Supplier>;
    deductionLists(warehouseId: string, offset?: number, limit?: number, deductionDateUtc?: Date, deductionReason?: DeductionReason, isProcessed?: boolean): DeductionList[] | Promise<DeductionList[]>;
    deductionList(id: string, warehouseId: string): DeductionList | Promise<DeductionList>;
}

export interface IMutation {
    createAccount(data: AccountCreate): Account | Promise<Account>;
    removeAccount(id: string): boolean | Promise<boolean>;
    updateAccount(data: AccountUpdate, id: string): Account | Promise<Account>;
    removeCashRegister(deviceId: string): boolean | Promise<boolean>;
    updateBillPrinter(data: UpdateBillPrinter): CashRegister | Promise<CashRegister>;
    createCashRegister(data: CashRegisterCreate): CashRegister | Promise<CashRegister>;
    removeDevice(id: string): boolean | Promise<boolean>;
    createDevice(data: DeviceCreate): Device | Promise<Device>;
    createVenue(data: VenueCreate): Venue | Promise<Venue>;
    removeVenue(id: string): boolean | Promise<boolean>;
    updateVenue(data: VenueUpdate, id: string): Venue | Promise<Venue>;
    createCategory(name: string, id?: string, parentCategoryId?: string, childCategories?: string[], color?: Color): Category | Promise<Category>;
    removeCategory(id: string): boolean | Promise<boolean>;
    updateCategory(data: UpdateCategory, id: string): Category | Promise<Category>;
    createRecipeLine(data: RecipeLineCreate): RecipeLine | Promise<RecipeLine>;
    updateRecipeLine(data: RecipeLineUpdate): RecipeLine | Promise<RecipeLine>;
    removeRecipeLine(id: string): boolean | Promise<boolean>;
    createWarehouse(data: WarehouseCreate): Warehouse | Promise<Warehouse>;
    updateWarehouse(data: WarehouseUpdate, id: string): Warehouse | Promise<Warehouse>;
    removeWarehouse(id: string): boolean | Promise<boolean>;
    createStockCard(data: StockCardCreate): StockCard | Promise<StockCard>;
    updateStockCard(data: StockCardUpdate, id: string): StockCard | Promise<StockCard>;
    removeStockCard(id: string): boolean | Promise<boolean>;
    createRecipe(data: RecipeCreate): Recipe | Promise<Recipe>;
    updateRecipe(data: RecipeUpdate): Recipe | Promise<Recipe>;
    removeRecipe(id: string): boolean | Promise<boolean>;
    createProduct(data: ProductCreate): Product | Promise<Product>;
    createProductAndRecipe(product: ProductCreate, recipe?: RecipeCreateWithProduct): Product | Promise<Product>;
    removeProduct(id: string): boolean | Promise<boolean>;
    updateProduct(data: ProductUpdate, id: string): Product | Promise<Product>;
    updateProductAndRecipe(id: string, product: ProductUpdate, recipe?: RecipeUpdateWithProduct): Product | Promise<Product>;
    createDiscount(data: DiscountCreate): Discount | Promise<Discount>;
    updateDiscount(data: DiscountUpdate): Discount | Promise<Discount>;
    removeDiscount(id: string): boolean | Promise<boolean>;
    registerEmployee(data: EmployeeRegister): Employee | Promise<Employee>;
    removeEmployee(id: string): boolean | Promise<boolean>;
    updateEmployee(data: EmployeeUpdate, id: string): Employee | Promise<Employee>;
    addEmployeeVenue(venueId: string, id: string): Employee | Promise<Employee>;
    removeEmployeeVenue(venueId: string, id: string): Employee | Promise<Employee>;
    switchVenue(venueId: string): string | Promise<string>;
    deleteEmployee(id: string): boolean | Promise<boolean>;
    voidBill(id: string): Bill | Promise<Bill>;
    updateBill(data: UpdateBill): Bill | Promise<Bill>;
    createEnterprise(data: EnterpriseCreate): Enterprise | Promise<Enterprise>;
    removeEnterprise(id: string): boolean | Promise<boolean>;
    updateEnterprise(data: EnterpriseUpdate, id: string): Enterprise | Promise<Enterprise>;
    discountOrderPreview(data: OrderDiscountInput): OrderDiscountPreview | Promise<OrderDiscountPreview>;
    createOrder(data: OrderCreate): Order | Promise<Order>;
    createAndPayOrder(data: OrderCreateAndPay): Order | Promise<Order>;
    addToOrder(data: AddToOrder): Order | Promise<Order>;
    payOrder(data: PayOrder): Order | Promise<Order>;
    splitOrderPayment(data: OrderSplit): Order | Promise<Order>;
    cancelOrder(data: OrderCancel): Order | Promise<Order>;
    cancelOrderLines(data: CancelOrderLines): Order | Promise<Order>;
    moveOrder(data: MoveOrder): Order[] | Promise<Order[]>;
    moveOrderLines(data: MoveOrderLines): Order[] | Promise<Order[]>;
    scheduleOrder(data: ScheduleOrder): Order | Promise<Order>;
    updateOrderName(data: UpdateOrderName): Order | Promise<Order>;
    removePlace(id: string): boolean | Promise<boolean>;
    createPlace(data: PlaceCreate): Place | Promise<Place>;
    updatePlace(data: PlaceUpdate, id: string): Place | Promise<Place>;
    createSection(): Section | Promise<Section>;
    updateSectionName(data: SectionUpdateName, id: string): Section | Promise<Section>;
    updateSectionsOrdering(data: SectionUpdateOrder): Section[] | Promise<Section[]>;
    removeSection(id: string): boolean | Promise<boolean>;
    startShift(): Shift | Promise<Shift>;
    endShift(id: string): Shift | Promise<Shift>;
    loginEmployee(data: LoginEmployee): string | Promise<string>;
    checkToken(token: string): boolean | Promise<boolean>;
    uploadCertificate(password: string, file: Upload): boolean | Promise<boolean>;
    startVenueShift(data: StartVenueShift): VenueShift | Promise<VenueShift>;
    finishVenueShift(data: FinishVenueShift): VenueShift | Promise<VenueShift>;
    createCashDrawerOperation(data: CreateCashDrawerOperation): CashDrawerOperation | Promise<CashDrawerOperation>;
    createCustomer(data: CustomerCreate): Customer | Promise<Customer>;
    removeCustomer(id: string): boolean | Promise<boolean>;
    updateCustomer(data: CustomerUpdate): Customer | Promise<Customer>;
    createStockCardCategory(data: StockCardCategoryCreate): StockCardCategory | Promise<StockCardCategory>;
    updateStockCardCategory(data: StockCardCategoryUpdate, id: string): StockCardCategory | Promise<StockCardCategory>;
    removeStockCardCategory(id: string): boolean | Promise<boolean>;
    createInventoryCountItem(data: InventoryCountItemCreate, warehouseId: string, inventoryCountId: string): InventoryCountItem | Promise<InventoryCountItem>;
    updateInventoryCountItem(data: InventoryCountItemUpdate, warehouseId: string, inventoryCountId: string, id: string): InventoryCountItem | Promise<InventoryCountItem>;
    createInventoryCount(warehouseId: string): InventoryCount | Promise<InventoryCount>;
    finishInventoryCount(id: string, warehouseId: string): InventoryCount | Promise<InventoryCount>;
    createDeliveryList(data: DeliveryListCreate): DeliveryList | Promise<DeliveryList>;
    updateDeliveryList(data: DeliveryListUpdate): DeliveryList | Promise<DeliveryList>;
    removeDeliveryList(id: string, warehouseId: string): boolean | Promise<boolean>;
    createSupplier(data: SupplierCreate): Supplier | Promise<Supplier>;
    updateSupplier(data: SupplierUpdate): Supplier | Promise<Supplier>;
    updateDeductionListItem(data: DeductionListItemUpdate, warehouseId: string, deductionListId: string, id: string): DeductionListItem | Promise<DeductionListItem>;
    createDeductionListItem(data: DeductionListItemCreate, warehouseId: string, deductionListId: string): DeductionListItem | Promise<DeductionListItem>;
    removeDeductionListItem(warehouseId: string, deductionListId: string, id: string): boolean | Promise<boolean>;
    createDeductionList(data: DeductionListCreate): DeductionList | Promise<DeductionList>;
    updateDeductionList(data: DeductionListUpdate): DeductionList | Promise<DeductionList>;
    removeDeductionList(id: string, warehouseId: string): boolean | Promise<boolean>;
}

export interface ISubscription {
    orderUpdates(): OrderUpdatesSubscription | Promise<OrderUpdatesSubscription>;
}

export type Timeline = any;
export type Upload = any;
